var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showMoreButton
      ? _c("button", { on: { click: _vm.showMore } }, [
          _vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "More")) + "\n\t")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showSaveButton
      ? _c(
          "button",
          { staticClass: "primary", on: { click: _vm.saveThisOnly } },
          [_vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "Save")) + "\n\t")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.shoUpdateButton
      ? _c(
          "button",
          { staticClass: "primary", on: { click: _vm.saveThisOnly } },
          [_vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "Update")) + "\n\t")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showUpdateOnlyThisButton
      ? _c(
          "button",
          { staticClass: "primary", on: { click: _vm.saveThisOnly } },
          [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.$t("calendar", "Update this occurrence")) +
                "\n\t"
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showUpdateThisAndFutureButton
      ? _c(
          "button",
          {
            class: { primary: _vm.forceThisAndAllFuture },
            on: { click: _vm.saveThisAndAllFuture }
          },
          [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.$t("calendar", "Update this and all future")) +
                "\n\t"
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }